/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LclFeeInfoDto
 */
export interface LclFeeInfoDto {
    /**
     * 
     * @type {number}
     * @memberof LclFeeInfoDto
     */
    blChargeFee?: number;
    /**
     * 
     * @type {number}
     * @memberof LclFeeInfoDto
     */
    containerHandlingFee?: number;
    /**
     * 
     * @type {number}
     * @memberof LclFeeInfoDto
     */
    handlingChargeFee?: number;
    /**
     * 
     * @type {number}
     * @memberof LclFeeInfoDto
     */
    bondedWarehouseDeliveryFee?: number;
    /**
     * 
     * @type {number}
     * @memberof LclFeeInfoDto
     */
    lclFeeOrderId?: number;
    /**
     * 
     * @type {string}
     * @memberof LclFeeInfoDto
     */
    lclFeeOrderCode?: string;
}

/**
 * Check if a given object implements the LclFeeInfoDto interface.
 */
export function instanceOfLclFeeInfoDto(value: object): value is LclFeeInfoDto {
    return true;
}

export function LclFeeInfoDtoFromJSON(json: any): LclFeeInfoDto {
    return LclFeeInfoDtoFromJSONTyped(json, false);
}

export function LclFeeInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LclFeeInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'blChargeFee': json['blChargeFee'] == null ? undefined : json['blChargeFee'],
        'containerHandlingFee': json['containerHandlingFee'] == null ? undefined : json['containerHandlingFee'],
        'handlingChargeFee': json['handlingChargeFee'] == null ? undefined : json['handlingChargeFee'],
        'bondedWarehouseDeliveryFee': json['bondedWarehouseDeliveryFee'] == null ? undefined : json['bondedWarehouseDeliveryFee'],
        'lclFeeOrderId': json['lclFeeOrderId'] == null ? undefined : json['lclFeeOrderId'],
        'lclFeeOrderCode': json['lclFeeOrderCode'] == null ? undefined : json['lclFeeOrderCode'],
    };
}

export function LclFeeInfoDtoToJSON(json: any): LclFeeInfoDto {
    return LclFeeInfoDtoToJSONTyped(json, false);
}

export function LclFeeInfoDtoToJSONTyped(value?: LclFeeInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'blChargeFee': value['blChargeFee'],
        'containerHandlingFee': value['containerHandlingFee'],
        'handlingChargeFee': value['handlingChargeFee'],
        'bondedWarehouseDeliveryFee': value['bondedWarehouseDeliveryFee'],
        'lclFeeOrderId': value['lclFeeOrderId'],
        'lclFeeOrderCode': value['lclFeeOrderCode'],
    };
}

